import React from 'react';

import { useSearchContext } from '@atlas/core';

import { useSearch } from 'hooks/useSearch';

import SearchResult from './SearchResult';

const SimpleSearchResult = () => {
  const { error, loading } = useSearchContext();
  const { isEmpty, isValidPrompt, searchString } = useSearch();

  if (!searchString || !isValidPrompt || isEmpty || error || loading) return null;

  return <SearchResult />;
};

export default SimpleSearchResult;
